null


// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/commands/DescribeStreamSummaryCommand.ts